import React from 'react'

export const UruguayIcon = (width = 24, height = 24) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_602_14535)">
        <path d="M0 0H24V24H0V0Z" fill="white" />
        <path
          d="M13.3125 2.66699H24V5.33418H13.3125V2.66699ZM13.3125 8.00137H24V10.6686H13.3125V8.00137ZM0 13.3311H24V16.0029H0V13.3311ZM0 18.6654H24V21.3373H0V18.6654Z"
          fill="#0038A8"
        />
        <path
          d="M6.36367 7.96937L6.80505 8.62845C4.99138 9.94096 6.09865 10.7171 4.81337 11.1372C5.61276 10.3571 4.68749 10.2913 5.36102 8.66531"
          fill="#FCD116"
        />
        <path
          d="M6.36367 7.96937L6.80505 8.62845C4.99138 9.94096 6.09865 10.7171 4.81337 11.1372C5.61276 10.3571 4.68749 10.2913 5.36102 8.66531"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
          strokeLinecap="square"
        />
        <path
          d="M6.04847 8.15686C5.04781 9.80614 5.70407 10.713 4.81367 11.1379"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M6.66613 6.66602H7.54613L6.66613 11.506L5.78613 6.66602H6.66613V11.506V6.66602Z"
          fill="#FCD116"
        />
        <path
          d="M6.66613 6.66602H7.54613L6.66613 11.506L5.78613 6.66602H6.66613ZM6.66613 6.66602V11.506"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M5.53089 7.37441L5.37696 8.15255C3.16641 7.79818 3.40055 9.12996 2.19464 8.5182C3.31154 8.53182 2.70378 7.83106 4.3298 7.15754"
          fill="#FCD116"
        />
        <path
          d="M5.53089 7.37441L5.37696 8.15255C3.16641 7.79818 3.40055 9.12996 2.19464 8.5182C3.31154 8.53182 2.70378 7.83106 4.3298 7.15754"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
          strokeLinecap="square"
        />
        <path
          d="M5.17639 7.28382C3.30261 7.74246 3.12543 8.84774 2.19534 8.51861"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M6.6662 6.6662L7.28845 7.28845L3.2438 10.0886L6.04395 6.04395L6.6662 6.6662L3.2438 10.0886L6.6662 6.6662Z"
          fill="#FCD116"
        />
        <path
          d="M6.6662 6.6662L7.28845 7.28845L3.2438 10.0886L6.04395 6.04395L6.6662 6.6662ZM6.6662 6.6662L3.2438 10.0886"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M5.36266 6.36367L4.70358 6.80505C3.39107 4.99138 2.61492 6.09865 2.1948 4.81337C2.97493 5.61276 3.04069 4.68749 4.66672 5.36102"
          fill="#FCD116"
        />
        <path
          d="M5.36266 6.36367L4.70358 6.80505C3.39107 4.99138 2.61492 6.09865 2.1948 4.81337C2.97493 5.61276 3.04069 4.68749 4.66672 5.36102"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
          strokeLinecap="square"
        />
        <path
          d="M5.17517 6.04847C3.52589 5.04781 2.61906 5.70407 2.19412 4.81367"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M6.66602 6.66613V7.54613L1.82601 6.66613L6.66602 5.78613V6.66613H1.82601H6.66602Z"
          fill="#FCD116"
        />
        <path
          d="M6.66602 6.66613V7.54613L1.82601 6.66613L6.66602 5.78613V6.66613ZM6.66602 6.66613H1.82601"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M5.95762 5.53089L5.17948 5.37696C5.53385 3.16641 4.20207 3.40055 4.81383 2.19464C4.80021 3.31154 5.50097 2.70378 6.17449 4.3298"
          fill="#FCD116"
        />
        <path
          d="M5.95762 5.53089L5.17948 5.37696C5.53385 3.16641 4.20207 3.40055 4.81383 2.19464C4.80021 3.31154 5.50097 2.70378 6.17449 4.3298"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
          strokeLinecap="square"
        />
        <path
          d="M6.04821 5.17639C5.58957 3.30261 4.4843 3.12543 4.81342 2.19534"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M6.66583 6.6662L6.04358 7.28845L3.24343 3.2438L7.28809 6.04395L6.66583 6.6662L3.24343 3.2438L6.66583 6.6662Z"
          fill="#FCD116"
        />
        <path
          d="M6.66583 6.6662L6.04358 7.28845L3.24343 3.2438L7.28809 6.04395L6.66583 6.6662ZM6.66583 6.6662L3.24343 3.2438"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M6.96836 5.36266L6.52698 4.70358C8.34065 3.39107 7.23339 2.61492 8.51866 2.1948C7.71927 2.97493 8.64454 3.04069 7.97101 4.66672"
          fill="#FCD116"
        />
        <path
          d="M6.96836 5.36266L6.52698 4.70358C8.34065 3.39107 7.23339 2.61492 8.51866 2.1948C7.71927 2.97493 8.64454 3.04069 7.97101 4.66672"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
          strokeLinecap="square"
        />
        <path
          d="M7.28357 5.17517C8.28422 3.52589 7.62796 2.61906 8.51836 2.19412"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M6.6659 6.66602H5.7859L6.6659 1.82601L7.5459 6.66602H6.6659V1.82601V6.66602Z"
          fill="#FCD116"
        />
        <path
          d="M6.6659 6.66602H5.7859L6.6659 1.82601L7.5459 6.66602H6.6659ZM6.6659 6.66602V1.82601"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M7.80114 5.95762L7.95508 5.17948C10.1656 5.53385 9.93148 4.20207 11.1374 4.81383C10.0205 4.80021 10.6283 5.50097 9.00223 6.17449"
          fill="#FCD116"
        />
        <path
          d="M7.80114 5.95762L7.95508 5.17948C10.1656 5.53385 9.93148 4.20207 11.1374 4.81383C10.0205 4.80021 10.6283 5.50097 9.00223 6.17449"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
          strokeLinecap="square"
        />
        <path
          d="M8.15564 6.04821C10.0294 5.58957 10.2066 4.4843 11.1367 4.81342"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M6.66583 6.66583L6.04358 6.04358L10.0882 3.24343L7.28809 7.28809L6.66583 6.66583L10.0882 3.24343L6.66583 6.66583Z"
          fill="#FCD116"
        />
        <path
          d="M6.66583 6.66583L6.04358 6.04358L10.0882 3.24343L7.28809 7.28809L6.66583 6.66583ZM6.66583 6.66583L10.0882 3.24343"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M7.96937 6.96836L8.62845 6.52698C9.94096 8.34065 10.7171 7.23339 11.1372 8.51866C10.3571 7.71927 10.2913 8.64454 8.66531 7.97101"
          fill="#FCD116"
        />
        <path
          d="M7.96937 6.96836L8.62845 6.52698C9.94096 8.34065 10.7171 7.23339 11.1372 8.51866C10.3571 7.71927 10.2913 8.64454 8.66531 7.97101"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
          strokeLinecap="square"
        />
        <path
          d="M8.15686 7.28357C9.80614 8.28422 10.713 7.62796 11.1379 8.51836"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M6.66602 6.6659V5.7859L11.506 6.6659L6.66602 7.5459V6.6659H11.506H6.66602Z"
          fill="#FCD116"
        />
        <path
          d="M6.66602 6.6659V5.7859L11.506 6.6659L6.66602 7.5459V6.6659ZM6.66602 6.6659H11.506"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M7.37441 7.80114L8.15255 7.95508C7.79818 10.1656 9.12996 9.93148 8.5182 11.1374C8.53182 10.0205 7.83106 10.6283 7.15754 9.00223"
          fill="#FCD116"
        />
        <path
          d="M7.37441 7.80114L8.15255 7.95508C7.79818 10.1656 9.12996 9.93148 8.5182 11.1374C8.53182 10.0205 7.83106 10.6283 7.15754 9.00223"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
          strokeLinecap="square"
        />
        <path
          d="M7.28382 8.15564C7.74246 10.0294 8.84774 10.2066 8.51861 11.1367"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M6.6662 6.66583L7.28845 6.04358L10.0886 10.0882L6.04395 7.28809L6.6662 6.66583L10.0886 10.0882L6.6662 6.66583Z"
          fill="#FCD116"
        />
        <path
          d="M6.6662 6.66583L7.28845 6.04358L10.0886 10.0882L6.04395 7.28809L6.6662 6.66583ZM6.6662 6.66583L10.0886 10.0882"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M6.66607 8.2794C7.55709 8.2794 8.2794 7.55709 8.2794 6.66607C8.2794 5.77505 7.55709 5.05273 6.66607 5.05273C5.77505 5.05273 5.05273 5.77505 5.05273 6.66607C5.05273 7.55709 5.77505 8.2794 6.66607 8.2794Z"
          fill="#FCD116"
          stroke="black"
          strokeWidth="0.234667"
          strokeMiterlimit="20"
        />
        <path
          d="M7.85328 6.02009C7.75061 6.13742 7.69194 5.93209 7.32527 5.93209C6.95861 5.93209 6.89994 6.15209 6.84127 6.10809C6.7826 6.06409 7.14927 5.80009 7.26661 5.78542C7.38394 5.77076 7.72127 5.88809 7.85328 6.02009ZM7.42794 6.15209C7.53061 6.24009 7.44261 6.43076 7.33994 6.43076C7.23727 6.43076 7.04661 6.25476 7.13461 6.13742"
          fill="black"
        />
        <path
          d="M6.94336 6.28444C6.95803 6.10843 7.10469 6.0791 7.33936 6.0791C7.57403 6.0791 7.67669 6.2551 7.7647 6.2991C7.66203 6.2991 7.57403 6.15244 7.33936 6.15244C7.10469 6.15244 7.10469 6.15244 6.94336 6.2991V6.28444ZM6.98736 6.32844C7.04603 6.24044 7.11936 6.41644 7.28069 6.41644C7.44203 6.41644 7.53003 6.37244 7.63269 6.2991C7.73536 6.22577 7.48603 6.4751 7.32469 6.4751C7.16336 6.4751 6.94336 6.3871 6.98736 6.32844Z"
          fill="black"
        />
        <path
          d="M7.48647 6.41636C7.67713 6.3137 7.5598 6.16703 7.48647 6.1377C7.5158 6.16703 7.63313 6.3137 7.48647 6.41636ZM6.66513 7.29637C6.75313 7.29637 6.78246 7.26703 6.8998 7.26703C7.01713 7.26703 7.2958 7.42837 7.45713 7.3697C7.1198 7.5017 7.2518 7.4137 6.66513 7.4137H6.5918L6.66513 7.29637ZM7.5158 7.5017C7.45713 7.39903 7.4718 7.42837 7.35447 7.26703C7.4718 7.35503 7.50113 7.39903 7.5158 7.5017ZM6.66513 7.64837C7.0318 7.64837 6.97313 7.57503 7.45713 7.3697C7.10513 7.4137 7.0318 7.53103 6.66513 7.53103H6.5918L6.66513 7.64837ZM6.66513 7.1057C6.7678 7.1057 6.79713 7.03237 6.91446 7.03237C7.0318 7.03237 7.19313 7.07637 7.26647 7.13503C7.28113 7.1497 7.22247 7.0177 7.10513 7.00303C6.9878 6.98837 7.0318 6.7977 6.8998 6.76836C6.8998 6.82703 6.9438 6.81236 6.95846 6.90036C6.95846 6.9737 6.82646 6.9737 6.79713 6.90036C6.82646 7.0177 6.73846 7.0177 6.66513 7.0177"
          fill="black"
        />
        <path
          d="M5.47778 6.02009C5.58045 6.13742 5.63911 5.93209 6.00578 5.93209C6.37245 5.93209 6.43112 6.15209 6.48978 6.10809C6.54845 6.06409 6.18178 5.80009 6.06445 5.78542C5.94711 5.77076 5.60978 5.88809 5.47778 6.02009ZM5.90311 6.15209C5.80045 6.24009 5.88845 6.43076 5.99111 6.43076C6.09378 6.43076 6.28445 6.25476 6.19645 6.13742"
          fill="black"
        />
        <path
          d="M6.3877 6.28444C6.37303 6.10843 6.22636 6.0791 5.99169 6.0791C5.75703 6.0791 5.65436 6.2551 5.56636 6.2991C5.66903 6.2991 5.75703 6.15244 5.99169 6.15244C6.22636 6.15244 6.22636 6.15244 6.3877 6.2991V6.28444ZM6.3437 6.32844C6.28503 6.24044 6.21169 6.41644 6.05036 6.41644C5.88903 6.41644 5.80103 6.37244 5.69836 6.2991C5.59569 6.22577 5.84503 6.4751 6.00636 6.4751C6.16769 6.4751 6.3877 6.3871 6.3437 6.32844Z"
          fill="black"
        />
        <path
          d="M5.84459 6.41636C5.65392 6.3137 5.77125 6.16703 5.84459 6.1377C5.81525 6.16703 5.69792 6.3137 5.84459 6.41636ZM6.66592 7.29637C6.57792 7.29637 6.54859 7.26703 6.43126 7.26703C6.31392 7.26703 6.03526 7.42837 5.87392 7.3697C6.21126 7.5017 6.07926 7.4137 6.66592 7.4137H6.73926L6.66592 7.29637ZM5.81525 7.5017C5.87392 7.39903 5.85925 7.42837 5.97659 7.26703C5.85925 7.35503 5.82992 7.39903 5.81525 7.5017ZM6.66592 7.64837C6.29926 7.64837 6.35792 7.57503 5.87392 7.3697C6.22592 7.4137 6.29926 7.53103 6.66592 7.53103H6.73926L6.66592 7.64837ZM6.66592 7.1057C6.56326 7.1057 6.53392 7.03237 6.41659 7.03237C6.29926 7.03237 6.13792 7.07637 6.06459 7.13503C6.04992 7.1497 6.10859 7.0177 6.22592 7.00303C6.34326 6.98837 6.29926 6.7977 6.43126 6.76836C6.43126 6.82703 6.38726 6.81236 6.37259 6.90036C6.37259 6.9737 6.50459 6.9737 6.53392 6.90036C6.50459 7.0177 6.59259 7.0177 6.66592 7.0177"
          fill="black"
        />
        <path
          d="M6.66566 7.78027C6.59233 7.78027 6.40166 7.82427 6.66566 7.82427C6.92966 7.82427 6.739 7.78027 6.66566 7.78027Z"
          fill="black"
        />
      </g>
      <rect
        x="0.25"
        y="0.25"
        width="23.5"
        height="23.5"
        rx="11.75"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.5"
      />
      <defs>
        <clipPath id="clip0_602_14535">
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
